var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernment3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.35,
    x2: 124.15,
    y1: 124.15,
    y2: 21.35,
    gradientTransform: "rotate(73.15 .003 .01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: -48.539,
    cy: 90.714,
    r: 72.75,
    fill: "url(#a)",
    style: {
      fill: "url(#a)"
    },
    transform: "rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#624de3",
    d: "M72.756 62.718c2.016 0 3.937-.8 5.377-2.21a7.48 7.48 0 0 0 2.209-5.347c0-2.018-.8-3.94-2.209-5.348-2.848-2.85-7.842-2.882-10.723 0-1.44 1.44-2.208 3.33-2.24 5.348 0 2.017.8 3.939 2.208 5.38a7.6 7.6 0 0 0 5.346 2.21zm-2.4-9.991c1.28-1.281 3.552-1.281 4.833 0 .64.64.992 1.505.992 2.434 0 .928-.352 1.761-.992 2.434-1.28 1.28-3.553 1.28-4.834 0a3.4 3.4 0 0 1-.992-2.402c0-.897.352-1.762.992-2.434zm-32.201 16.46c1.12.8 2.432 1.25 3.809 1.25h61.616a6.4 6.4 0 0 0 4.801-2.146c1.249-1.377 1.825-3.203 1.633-5.06-.192-1.826-1.185-3.49-2.689-4.58l-30.792-22c-2.209-1.601-5.346-1.601-7.554 0l-30.792 22a6.56 6.56 0 0 0-2.4 3.235 6.13 6.13 0 0 0 0 4.003c.415 1.313 1.247 2.434 2.336 3.266zm1.632-5.956q.24-.72.864-1.153l30.793-22a2.26 2.26 0 0 1 1.344-.449c.48 0 .96.16 1.344.448l30.792 22.001c.545.384.897.993.96 1.633.065.673-.127 1.313-.575 1.794a2.35 2.35 0 0 1-1.729.768H41.964c-.48 0-.96-.16-1.377-.448a2.5 2.5 0 0 1-.832-1.153q-.24-.72 0-1.441zM108.157 99a6.44 6.44 0 0 0-4.577-1.889h-6.722V79.371a6.51 6.51 0 0 0-3.233-5.604 6.48 6.48 0 0 0-6.465 0 6.51 6.51 0 0 0-3.233 5.604v17.741h-4.641V79.371a6.51 6.51 0 0 0-3.233-5.604 6.48 6.48 0 0 0-6.466 0 6.51 6.51 0 0 0-3.233 5.604v17.741h-4.641V79.371a6.51 6.51 0 0 0-3.233-5.604c-1.984-1.153-4.481-1.153-6.498 0a6.51 6.51 0 0 0-3.232 5.604v17.741h-6.722a6.5 6.5 0 0 0-5.602 3.235 6.49 6.49 0 0 0 0 6.469 6.5 6.5 0 0 0 5.602 3.234h61.52c1.729 0 3.361-.672 4.577-1.89a6.45 6.45 0 0 0 1.889-4.579c0-1.73-.672-3.362-1.889-4.58zm-2.944 6.213a2.27 2.27 0 0 1-1.633.673H41.932c-.833 0-1.6-.448-2.017-1.153a2.29 2.29 0 0 1 0-2.306 2.35 2.35 0 0 1 2.017-1.153h8.802c1.152 0 2.08-.928 2.08-2.081V79.37c0-.833.449-1.601 1.153-2.018a2.28 2.28 0 0 1 2.305 0 2.35 2.35 0 0 1 1.152 2.018v19.823c0 1.153.928 2.081 2.08 2.081h8.803c1.152 0 2.08-.928 2.08-2.081V79.37c0-.833.448-1.601 1.153-2.018a2.28 2.28 0 0 1 2.304 0 2.35 2.35 0 0 1 1.153 2.018v19.823c0 1.153.928 2.081 2.08 2.081h8.802c1.153 0 2.08-.928 2.08-2.081V79.37c0-.833.45-1.601 1.153-2.018a2.28 2.28 0 0 1 2.305 0 2.35 2.35 0 0 1 1.152 2.018v19.823c0 1.153.928 2.081 2.08 2.081h8.803c.608 0 1.216.257 1.632.673.417.416.673 1.025.673 1.633s-.256 1.217-.673 1.633z",
    style: {
      fill: "#f5daec",
      fillOpacity: 1,
      strokeWidth: 3.20163
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment3);
export default __webpack_public_path__ + "static/media/government3.98ed8bec3e41616e3398e665633f4e11.svg";
export { ForwardRef as ReactComponent };